import config from 'volta/config/environment';

import * as Sentry from '@sentry/ember';

const {
  sentry: { enabled, dsn, environment },
  APP: { version }
} = config;

export const initSentry = () => {
  if (enabled) {
    Sentry.init({
      enabled,
      dsn,
      environment,
      release: 'volta@' + version.split('+').shift(),

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production,
      tracesSampleRate: 1,
      beforeBreadcrumb(breadcrumb) {
        // To avoid too long JSON messages (Error 412)
        if (breadcrumb.message?.startsWith('DEPRECATION:')) {
          return null;
        }
        return breadcrumb;
      },

      beforeSend(event, hint) {
        const error = hint?.originalException;
        // ignore aborted route transitions from the Ember.js router
        if ((error as Error)?.name === 'TransitionAborted') {
          return null;
        }

        return event;
      }
    });
  }
};
